import * as React from "react";
import { Link } from "react-router-dom";
import { useTranslations } from "next-intl";
import { Button, FormField, Input, useToast } from "@chotca/ui";
import { vi } from "@chotca/config";
import { getSdk } from "@chotca/api-client";
import { AuthLayout } from "./auth-layout";
import { errMsg } from "./auth-errors";

export function ForgotPasswordPage() {
  const t = useTranslations("auth");
  const { error: toastError, success: toastSuccess } = useToast();
  const [pending, setPending] = React.useState(false);
  const [sent, setSent] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setPending(true);
    setError(null);
    const fd = new FormData(e.currentTarget);
    const email = String(fd.get("email") ?? "").trim();
    try {
      await getSdk().auth.requestPasswordReset({ email });
      setSent(true);
      toastSuccess(t("forgotSent"));
    } catch (err) {
      const msg = errMsg(err, "Không gửi được liên kết");
      setError(msg);
      toastError(msg);
    } finally {
      setPending(false);
    }
  }

  return (
    <AuthLayout
      label={vi.common.login}
      title={t("forgotTitle")}
      subtitle={t("forgotSubtitle")}
      footer={
        <Link
          to="/login"
          className="font-bold text-ink underline-offset-4 hover:underline"
        >
          {t("loginLink")}
        </Link>
      }
    >
      {sent ? (
        <div className="rounded-2xl bg-mist p-4 text-sm text-ink/80">
          {t("forgotSent")}
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <FormField label={t("emailLabel")}>
            <Input
              name="email"
              type="email"
              autoComplete="email"
              required
              autoFocus
            />
          </FormField>

          {error ? (
            <p className="rounded-xl bg-danger/10 p-3 text-sm text-danger">
              {error}
            </p>
          ) : null}

          <Button type="submit" fullWidth loading={pending} size="lg">
            {t("forgotCta")}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
